import { IMobileBackBar, MobileBackBar } from './mobile-back-bar'

export { MobileBackBar }
export type { IMobileBackBar }
